import { debounce, generateGuid, lockScroll } from "../helpers";
import { checkCart } from "../helpers";
import Cookies from "js-cookie";
import gsap from "gsap";
import { Thumbs } from "swiper";

class BuildABox extends HTMLElement {
	// static get observedAttributes() {
	// 	return ["open", "fullscreen"];
	// }

	constructor() {
		super();

		this.boxFull = false;
		this.editMode = false;
		this.sectionId = this.dataset.sectionId;

		this.bab = this.querySelector(".build-a-box");
		this.guid = generateGuid();
		this.boxId =
			localStorage.getItem("boxId") && localStorage.getItem("boxId") !== ""
				? localStorage.getItem("boxId")
				: this.guid;
		this.isOpen = false;
		this.fullscreen = false;
		this.overlay = document.querySelector(".overlay-bab");
		this.headerContainer = this.querySelector(".build-a-box-header-container");
		this.progressBar = this.querySelector(".progress-bar");
		this.progressCounters = [...this.querySelectorAll(".progress-bar > div")];
		this.closedOffset = "100%";

		this.frames = this.querySelectorAll(".frame");
		this.currentFrame = 0; // negative, since first frame
		this.currentTab = 0;
		this.boxContext = null;

		this.upgradeModal = this.querySelector("modal-popup");

		/** Box inputs */
		this.boxProduct = null;
		this.dataObj = null;
		this.boxTypeSelectors = this.querySelectorAll(
			"[data-step='select-box'] button"
		);
		this.sizeInputsTrigger = this.querySelectorAll(
			".build-a-box-size-selector"
		);
		this.sizeInputs = this.querySelectorAll("[name='box-size']");
		this.selectedSize = this.querySelector("[name='box-size']:checked");
		this.presetInputs = this.querySelectorAll(".select-preset");
		this.selectedPreset = null;
		this.presetJson = null;
		this.presetHandle = null;
		this.sizeJson = JSON.parse(this.selectedSize.value);
		this.boxRadios = this.querySelectorAll("[name='subscription']");
		this.subRadio = this.querySelector("#bab-sub");
		this.subTextEls = this.querySelectorAll("[data-subscription-text]");

		/** Cart backup check */
		this.framesWrapper = this.querySelector(".frames-wrapper");

		/** Cart backup check */
		let cart = document.querySelector("cart-wrapper");
		if (cart) {
			let field = cart.querySelector("input[name='discount']");

			if (field && field.value != this.sizeJson.subscription_shipping_code) {
				field.value = this.sizeJson.subscription_shipping_code;
			}
		}

		/** the btns */
		this.stepsBtns = this.querySelectorAll(".steps-row button");
		this.openBtns = document.querySelectorAll(".js-open");
		this.closeBtns = this.querySelectorAll(".js-close");
		this.navigateButtons = this.querySelectorAll("[data-bab-nav]");
		this.prevTabBtns = this.querySelectorAll(".js-prev-tab");
		this.prevFrameBtns = this.querySelectorAll(".js-prev-frame");
		this.nextTabBtns = this.querySelectorAll(".js-next-tab");
		this.nextFrameBtns = this.querySelectorAll(".js-next-frame");
		this.jumpFrameBtns = this.querySelectorAll(".js-jump-frame");
		this.jumpNextFrameBtns = this.querySelectorAll(".js-jump-next-frame");
		this.editBtn = this.querySelector(".js-edit");
		this.upgradeBtn = this.querySelector(".js-upgrade");
		this.locked = false;

		/** product objects */
		this.products = {};
		this.productCount = 0;
		this.pointsCount = 0;
		this.productMax = this.sizeJson.max_size;
		this.subscription = false;

		/** UI */
		this.capacityBars = this.querySelectorAll(".fill-progress");
		this.buildableProducts = this.querySelectorAll(
			".custom-box build-a-box-product"
		);
		this.productAnimEl = this.querySelector(".box-products-list");
		this.countdown = 1000;
		this.priceEl = this.querySelectorAll(".box-price");

		this.stepProgressBar = this.querySelector(".progress-bar");
		this.progressSteps = [
			...this.stepProgressBar.querySelectorAll(".container > div"),
		];
		this.activeStep = this.stepProgressBar.querySelector(".active");
		this.summaries = this.querySelectorAll(".box-summary");
		this.emptyStates = this.querySelectorAll(".box--empty-state");
		this.atc = this.querySelector(".js-box-atc");

		this.productBackBtn = this.querySelector('[data-tab="summary"] .js-back');
		this.productNextBtn = this.querySelector(
			'[data-tab="summary"] .js-next'
		);
		// this.reviewPresetBtn = this.querySelector(
		// 	"[data-tab='select-preset'] button[disabled].js-jump-next-frame"
		// );

		/** Cookies? */
		this.appliedDiscount =
			window.localStorage.getItem("discount_code") ||
			(window.Cookiebot?.consented && Cookies.get("discount_code"));
		this.appliedDiscountValue = window.localStorage.getItem("discount_value")
			? parseInt(window.localStorage.getItem("discount_value"))
			: 0;

		if (this.appliedDiscount != window.localStorage.getItem("discount_code")) {
			window.localStorage.setItem("discount_code", this.appliedDiscount);
		}

		if (
			this.appliedDiscountValue != window.localStorage.getItem("discount_value")
		) {
			window.localStorage.setItem("discount_value", this.appliedDiscountValue);
		}

		// on mount
		this.dataset.guid = this.guid;
		this.setFrameImmediately(0);
		this.bindEvents();

		if (location.search === "?build-a-box") this.open(true);

		// DEBUG
		// this.open(true);
		// this.setFrameImmediately(2, 1);
		// this.close(true)

		this.sizeTabs();
	}

	sizeTabs() {
		const iOS =
			!!window.navigator.userAgent.match(/iPad/i) ||
			!!window.navigator.userAgent.match(/iPhone/i);

		// Only an issue on Safari mobile
		if (!iOS) return;

		const sizeTabs = () => {
			this.querySelector(
				'[data-tab="review"]'
				).style.height = `calc(${window.innerHeight - 114}px)`;
		}

		sizeTabs();
		addEventListener("resize", () => sizeTabs());
		addEventListener("scroll", () => sizeTabs()); //For safari url bar
	}

	navigate(frame = 0, tab = 0) {
		this.currentFrame = frame;
		this.currentTab = tab;
		this.dataset.frame = String(frame);
		this.dataset.tab = String(tab);

		// Reset tabs
		this.querySelectorAll(".tab").forEach((tmpTab) => {
			tmpTab.classList.remove("js-active");
		});

		this.frames.forEach((tmpFrame, tmpFrameKey) => {
			// Reset frames
			tmpFrame.classList.remove("js-past");
			tmpFrame.classList.remove("js-active");
			const frameTabs = this.frames[tmpFrameKey].querySelectorAll(".tab");

			if (tmpFrameKey == frame) {
				// Current frame
				tmpFrame.classList.add("js-active");

				// Set focus trap to only return elements in this frame + header elements
				// Review step unique, trap to just review tab
				if (frame == 3 && tab == 1) {
					this.setFocusTrap([frameTabs[tab], this.headerContainer]);
				} else {
					this.setFocusTrap([tmpFrame, this.headerContainer]);
				}
			} else if (tmpFrameKey < frame) {
				tmpFrame.classList.add("js-past");
			}

			if (tmpFrameKey == frame && frameTabs.length) {
				frameTabs.forEach((tmpTab, tmpTabKey) => {
					if (tmpTabKey == tab) {
						// Current tab
						tmpTab.classList.add("js-active");
					}
				});
			}
		});

		// Review step is unique.
		// if ()

		this.updateStepsBtns();
	}

	/*
	 * Update steps nav
	 */
	updateStepsBtns() {
		// Set steps nav as active
		this.stepProgressBar.classList[this.currentFrame > 0 ? "add" : "remove"](
			"started"
		);

		// Update step 2 button
		this.stepsBtns[1].disabled = this.boxContext ? false : true;
		// TODO: Update this step only when box full
		this.stepsBtns[2].disabled = this.boxFull ? false : true;

		// Reset all to start
		this.stepsBtns.forEach((btn) => btn.classList.remove("active"));

		// Set step button classes
		if (this.currentFrame == 3 && this.currentTab == 0) {
			this.stepsBtns[1].classList.add("active");
		} else if (this.currentFrame == 3 && this.currentTab == 1) {
			this.stepsBtns[2].classList.add("active");
		} else {
			this.stepsBtns[0].classList.add("active");
		}
	}

	setBoxType(type = "custom") {
		// Back out if no change
		if (type == this.boxContext) return;

		this.boxContext = type;
		this.dataset.boxType = type;

		// Update back/next
		this.productBackBtn.dataset.babNav = type == "custom" ? "2" : "1";
		this.productNextBtn.disabled = true;

		if (type == "custom") {
			// Reset selected box area
			this.querySelectorAll(".preset-box").forEach((box) => {
				box.classList.remove("is-selected");
			});
			this.querySelectorAll("build-a-box-product").forEach((babProd) => {
				babProd.classList.remove("current-selection");
			});
		}

		// Reset
		// this.querySelectorAll("[data-summary-title]").forEach((summaryTitle) => {
		// 	summaryTitle.textContent = "Build-a-Box";
		// });

		this.emptyProducts();

		this.updateStepsBtns();
	}

	emptyProducts() {
		this.products = {};
		this.productCount = 0;
		this.pointsCount = 0;
		this.boxPrice = 0;
		this.boxFull = false;
		this.writeLineItems();
		this.displayPrice();

		// Reset each product card val
		this.querySelectorAll("build-a-box-product quantity-input input").forEach(
			(input) => {
				input.value = 0;
			}
		);

		// Reset animated product
		this.productAnimEl?.querySelectorAll(".summary-image").forEach((item) => {
			item.remove();
		});

		this.recalculateAvailableBoxSpace();

		// Reset progress bar
		this.capacityBars.forEach(bar => bar.style.width = "0");
	}

	getTabbableElements(context = this) {
		return context.querySelectorAll(
			'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
		);
	}

	recalculateAvailableBoxSpace() {
		const boxMaxSize = Number(this.sizeJson.max_size);
		const boxCurrentSize = this.pointsCount;

		if (boxCurrentSize <= boxMaxSize) {
			if (boxMaxSize - boxCurrentSize >= 3.5) {
				this.enableAllAddButtons();
			}
		}
		else {
			const boxPointsToMinus = boxCurrentSize - boxMaxSize;

			Object.entries(this.products).map(([productId, product]) => {
				const productPointsTotal = product.points;
				const productPointsPerItem = productPointsTotal / product.quantity;
				const newValue = productPointsTotal <= boxPointsToMinus ? 0 : product.quantity - Math.floor(boxPointsToMinus / productPointsPerItem);

				// Update
				const currentProdEl = document.querySelector(`build-a-box-product[data-variant-id="${productId}"]`);
				const currentProdInput = currentProdEl.querySelector('input');
				currentProdInput.value = newValue;
				currentProdInput.dispatchEvent(new Event("change"));
			});
		}
	}

	bindEvents() {
		/**
		 * Select the kind of box we'll be buying
		 */
		[...this.boxTypeSelectors].forEach((btn) => {
			btn.addEventListener(
				"click",
				debounce(() => {
					// let ctx = btn.dataset?.selection;
					// this.stepProgressBar.classList.remove("preset", "custom");
					// this.stepProgressBar.classList?.add(ctx);
					// this.boxContext = ctx;
					this.setBoxType(btn.dataset?.selection);
					this.updateStepsBtns();
				})
			);
		});

		/**
		 * NEW navigate
		 **/
		[...this.navigateButtons].forEach((btn) => {
			btn.addEventListener(
				"click",
				debounce(() => {
					const [frameId = 0, tabId = 0] = btn.dataset.babNav.split("|");
					this.navigate(Number(frameId), Number(tabId));

					if (btn.dataset.selection) {
						this.setBoxType(btn.dataset.selection);
					}
				}, 200).bind(this)
			);
		});

		/**
		 * Tab (in frame) events
		 */
		// [...this.prevTabBtns].forEach((btn) => {
		// 	btn.addEventListener(
		// 		"click",
		// 		debounce((event) => {
		// 			this.changeTab(event, false);
		// 		}, 200).bind(this)
		// 	);
		// });

		// [...this.nextTabBtns].forEach((btn) => {
		// 	const changeTab = (event) => this.changeTab(event, true);
		// 	btn.addEventListener(
		// 		"click",
		// 		debounce((event) => {
		// 			changeTab(event);
		// 		}, 200).bind(this)
		// 	);
		// 	btn.addEventListener("keyup", (e) => {
		// 		if (e.key === "Enter" || e.keyCode === 13) {
		// 			changeTab(e);
		// 		}
		// 	});
		// });

		// this.editBtn.addEventListener(
		// 	"click",
		// 	debounce((event) => {
		// 		this.editBox();
		// 	}, 200).bind(this),
		// 	true
		// );

		/**
		 * Frame change events
		 */
		// [...this.prevFrameBtns].forEach((btn) => {
		// 	btn.addEventListener(
		// 		"click",
		// 		debounce((event) => {
		// 			this.changeFrame(event, false);
		// 		}, 200).bind(this)
		// 	);
		// });

		// [...this.nextFrameBtns].forEach((btn) => {
		// 	btn.addEventListener(
		// 		"click",
		// 		debounce((event) => {
		// 			// Bounce on desktop because UX?
		// 			if (
		// 				!window.Zero.isPhone &&
		// 				(event.target
		// 					.closest("label")
		// 					?.classList.contains("select-preset") ||
		// 					event.target?.classList.contains("select-preset"))
		// 			)
		// 				return;
		// 			this.changeFrame(event, true);
		// 		}, 200).bind(this)
		// 	);
		// });

		// [...this.jumpFrameBtns].forEach((btn) => {
		// 	btn.addEventListener(
		// 		"click",
		// 		debounce((event) => {
		// 			let dataset = event.target.dataset;

		// 			let frame = parseInt(dataset.targetFrame);
		// 			let tab = parseInt(dataset.targetTab);

		// 			if (!frame) return;
		// 			if (!tab) {
		// 				tab = null;
		// 			} else {
		// 				tab = dataset.targetTab - 1;
		// 			}

		// 			if (!window.Zero.isPhone) {
		// 				this.setFrameImmediately(frame, tab);
		// 			} else {
		// 				this.changeFrame(event, false);
		// 			}
		// 		}, 200).bind(this)
		// 	);
		// });

		// this.jumpNextFrameBtns.forEach((btn) => {
		// 	btn.addEventListener(
		// 		"click",
		// 		debounce((event) => {
		// 			/* Only applies to step 2 -> 3 on desktop */
		// 			if (!window.Zero.isPhone) {
		// 				this.setFrameImmediately(3, null, true);
		// 			} else {
		// 				this.changeFrame(event);
		// 			}
		// 		}, 200).bind(this)
		// 	);
		// });

		/**
		 * Box size inputs
		 */
		[...this.sizeInputsTrigger].forEach((btn, btnIndex) => {
			btn.addEventListener(
				"click",
				debounce(() => {
					this.setSelectedSize(btn);
					/*
					 * TODO: Recalculate available space on the above setSelectedSize
					 * This may need to occur above, in setSelectedSize
					 * This would mean animateProduct + allow minus are deleted
					 */

					this.animateProduct();

					// Allow editing via minus button
					this.querySelector(
						"quantity-input button:first-child"
					).disabled = false;

					// this.selectedSize = btn.querySelector("input");
					// this.selectedSize.checked = true;
					// this.sizeJson = JSON.parse(this.selectedSize.value);
					// this.productMax = this.sizeJson.max_size;
					// this.changeSubPriceDisplay();

					this.recalculateAvailableBoxSpace();
				}, 200).bind(this)
			);
		});

		/**
		 * Preset box inputs
		 */
		[...this.presetInputs].forEach((input) => {
			input.closest("article").classList.remove("current-selection");

			input.addEventListener("click", (e) => {
				this.selectedPreset = input.querySelector("input");
				// this.reviewPresetBtn.disabled = false;

				const babProduct = e.target.closest("build-a-box-product");

				this.querySelectorAll("build-a-box-product").forEach((babProd) => {
					babProd.classList.remove("current-selection");
				});
				this.querySelectorAll(
					`build-a-box-product[data-variant-id="${babProduct.dataset.variantId}"]`
				).forEach((babProd) => {
					babProd.classList.add("current-selection");
				});

				// let prev = document.querySelector("article.current-selection");
				// if (prev) prev.classList.remove("current-selection");

				this.querySelectorAll(".preset-box").forEach((box) => {
					box.classList.add("is-selected");
				});
				// e.target.closest("article").classList.add("current-selection");

				// let product = e.target.closest("build-a-box-product");

				this.presetJson = this.selectedPreset
					? JSON.parse(this.selectedPreset.value)
					: "{}";

				const variantsWithHandlesQuantities = JSON.parse(
					babProduct.dataset.bundle
				);

				this.sizeJson = this.presetJson;
				// this.changeSubPriceDisplay();

				//Empty products then populate them from a clean list
				this.products = {};
				for (let variantHandle in variantsWithHandlesQuantities) {
					const productLine = document.querySelector(
						`build-a-box-product[data-handle="${variantHandle}"]`
					).productLine;

					productLine.quantity = variantsWithHandlesQuantities[variantHandle];

					this.products[productLine.line.variant] = productLine;
				}

				//Updating the first line works to update all lines. Could turn this into a method?
				const firstProductLine = this.products[Object.keys(this.products)[0]];

				this.lineItemModify(firstProductLine);
				this.changeSubPriceDisplay();

				// TODO: Should this be here? As in, shouldn't adding items manually increase the score and naturally mark the box as filled?
				this.productNextBtn.disabled = false;
				this.boxFull = true;

				this.updateStepsBtns();
			});
		});

		/**
		 * Box radio inputs
		 */
		[...this.boxRadios].forEach((input) => {
			input.addEventListener("change", () => {
				let selectedRadio = this.querySelector("[name='subscription']:checked");

				if (selectedRadio.value === "yes") {
					this.subscription = true;
				} else {
					this.subscription = false;
				}

				this.displayPrice(this.boxPrice);
			});
		});

		/**
		 *  Open
		 */
		[...this.openBtns].forEach((btn) => {
			btn.addEventListener("click", (event) => {
				event.preventDefault();
				event.stopPropagation();
				event.stopImmediatePropagation();

				this.open();
				document.querySelectorAll("slot-drawer").forEach((slotDrawer) => {
					if (slotDrawer.isOpen) {
						slotDrawer.drawerClose();
					}
				});
				// this.getTabbableElements(this.querySelector(".frame"))[0].focus();
			});
		});

		/**
		 * Close
		 */
		[...this.closeBtns].forEach((btn) => {
			btn.addEventListener("click", (event) => {
				this.close();
				event.preventDefault();
				event.stopPropagation();
				//Refresh if we were in edit mode
				if (this.editMode) window.location.reload();
			});
		});

		/**
		 * Add to cart
		 */
		this.atc.addEventListener(
			"click",
			debounce((event) => {
				const addToCart = () => this.addToCart(event);
				if (this.editMode) {
					this.cancelBox(addToCart);
				} else {
					addToCart();
				}
			}, 200).bind(this)
		);

		/**
		 * Upgrade size
		 */
		this.upgradeBtn.addEventListener("click", (event) => {
			this.upgradeSize();
		});
	}

	/**
	 * Change subscription pricing display
	 */
	changeSubPriceDisplay(product = undefined) {
		// TODO: set based on context
		let discountText = this.sizeJson.subscription_discount;

		const subscriptionLine = this.querySelector(
			'[data-step="review"] .box-subscription div:last-child'
		);
		// if (subscriptionLine.style.display == 'none') subscriptionLine.style.display == ''
		// if (!this.sizeJson.selling_plan_id) subscriptionLine.style.display = 'none'
		// if (this.boxContext === "preset") subscriptionLine.style.display = 'none'

		//Update variant title
		const preBuiltVariantTitle = document.querySelector(
			`build-a-box-product[data-variant-id="${this.sizeJson.variant_id}"] h4`
		);
		// document
		// 	.querySelectorAll("[data-summary-title]")
		// 	.forEach((summaryTitle) => {
		// 		summaryTitle.textContent = preBuiltVariantTitle
		// 			? preBuiltVariantTitle.textContent.trim()
		// 			: "Build-a-Box";
		// 	});

		if (product) {
			// return if no discount
			if (!product.discountOverride || product.discountOverride == "0") {
				[...this.subTextEls].forEach((el) => {
					el.textContent = ``;
				});

				return;
			}

			discountText = product.discountOverride;
		}

		[...this.subTextEls].forEach((el) => {
			el.textContent = `(Save ${discountText}%)`;
		});
	}

	/**
	 * Change tabs within frame
	 * @param {*} event
	 * @param {*} next
	 * @returns
	 */
	changeTab(event, next = true) {
		let tabs = this.frames[this.currentFrame].querySelectorAll(".tab");

		this.nextTab = next === true ? this.currentTab + 1 : this.currentTab - 1;

		let nextTab = tabs[this.nextTab];

		// this.frames[this.currentFrame]?.scrollTo(0, 0);
		// tabs[this.currentTab]?.scrollTo(0, 0);
		/** Now shift tabs */
		this.animateTabs(tabs[this.currentTab], nextTab, () => {
			// nextTab?.scrollTo(0, 0);
			this.currentTab = this.nextTab;
			this.frames[this.currentFrame].dataset.activeTab = this.nextTab;

			// this.getTabbableElements(nextTab)[0].focus();
		});
	}

	editBox() {
		if (this.boxContext === "preset") {
			// this.reviewPresetBtn.disabled = false;
			// this.querySelector(".preset-box").classList.remove("is-selected");
			// this.querySelector(".preset-box article").classList.remove(
			// 	"current-selection"
			// );
		}

		if (!window.Zero.isPhone) {
			this.setFrameImmediately(2);
		} else {
			// On mobile, allow it to slide te frame
			this.boxContext === "preset"
				? this.changeFrame("preset", false)
				: this.changeFrame("custom", false);
		}
	}

	updateProgress(nextFrameIndex) {
		this.stepProgressBar.querySelector(".active")?.classList.remove("active");
		this.progressSteps[nextFrameIndex - 1].classList.add("active");
	}

	/**
	 *
	 * @param {*} frame
	 * @param {*} idx
	 */
	hideShowTab(frame, idx = 0) {
		let tabs = frame.querySelectorAll(".tab");

		[...tabs].forEach((tab, i) => {
			if (i === idx) {
				tab.style.opacity = 1;
				tab.style.pointerEvents = "all";
			} else {
				tab.style.opacity = 0;
				tab.style.pointerEvents = "none";
			}
		});
	}

	/**
	 * Change frame
	 * @param {*} event
	 * @param {*} next
	 * @returns
	 */
	changeFrame(eventOrSelection, next = true) {
		if (eventOrSelection.target) eventOrSelection.preventDefault();

		/** Bounces */
		if (this.locked === true) return;
		if (this.currentFrame === 0 && next === false) return;
		if (this.currentFrame === 0) this.started();
		if (this.currentFrame === 2 && next === false) this.resetAll();
		if (this.currentFrame >= this.frames.length && next === true) return;

		this.nextStep =
			next === true ? this.currentFrame + 1 : this.currentFrame - 1;

		let nextFrame = this.frames[this.nextStep];

		let selection = null;

		if (typeof eventOrSelection === "string") {
			selection = eventOrSelection;
		} else if (eventOrSelection.target) {
			selection =
				eventOrSelection.target.closest("button").dataset.selection ||
				eventOrSelection.target.dataset.selection;
		}

		/** Controls subtab display */
		if (selection) {
			let innerFrames = nextFrame.querySelectorAll("[data-frame]");

			[...innerFrames].forEach((fr) => {
				if (fr.dataset.frame != selection) fr.classList.add("hidden");
				if (fr.dataset.frame == selection) fr.classList.remove("hidden");
			});
		}

		// this.updateProgress(this.nextStep);

		//  Move next frame to top
		// this.frames[this.currentFrame].scrollTo(0, 0);

		/** Now shift frames */
		// this.animateFrames(this.frames[this.currentFrame], nextFrame, () => {
		// 	this.currentFrame = this.nextStep;
		// 	nextFrame.scrollTo(0, 0);
		this.framesWrapper.scrollTo(0, 0);
		// this.getTabbableElements(nextFrame)[0].focus();
		// });
	}
	// or set frame for last step on desktop

	started() {
		this.stepProgressBar.classList.add("started");
	}

	/**
	 * Class function to start on other frames
	 * @param {*} frame
	 */
	setFrameImmediately(idx, tab = null, next = false) {
		if (idx === undefined) return;

		let current = this.frames[this.currentFrame];

		// current.scrollTop = 0;
		// this.frames[idx].scrollTop = 0;

		// this.frames[idx].style.transform = "translateX(0)";

		if (this.frames[idx] === current) return;

		// next
		// 	? (current.style.transform = "translateX(0)")
		// 	: (current.style.transform = "translateX(-100%)");

		// TODO: Fix tab assignment
		if (tab) {
			this.hideShowTab(this.frames[idx], tab);
		}

		this.nextStep =
			next === true ? this.currentFrame + 1 : this.currentFrame - 1;

		this.currentFrame = idx;
		// this.updateProgress(this.nextStep);
	}

	toggleOpen(e) {
		e.stopPropagation();

		if (this.isOpen) {
			this.close();
		} else {
			this.open();
		}
	}

	open(immediate = false) {
		this.tabIndex = 1;

		this.isOpen = true;

		lockScroll(true);

		if (immediate) {
			gsap.set(this.bab, {
				y: 0,
				pointerEvents: "all",
			});

			gsap.set(this.overlay, {
				opacity: 1,
			});
		} else {
			gsap.to(this.bab, {
				y: 0,
				pointerEvents: "all",
				ease: "elastic.out(1,0.7)",
			});

			gsap.to(this.overlay, {
				opacity: 1,
				duration: 0.2,
			});
		}

		this.framesWrapper?.scrollTo(0, 0);

		// If no tab open, open the first
		this.navigate(this.currentFrame, this.currentTab);
		// if (!this.querySelectorAll(".tab.js-active").length) {
		// 	 = 0; // negative, since first frame
		// 	;
		// }
	}

	setSelectedSize(inputTrigger) {
		this.selectedSize = inputTrigger.querySelector("input");
		this.selectedSize.checked = true;
		this.sizeJson = JSON.parse(this.selectedSize.value);
		this.productMax = this.sizeJson.max_size;
		this.changeSubPriceDisplay();
	}

	openInEditMode(boxData = [], type = "build-a-box") {
		/*
		 * NEW: Open sequence using new navigate functions
		 * NOTE: No need for preset bundle here,
		 * though work seems to have been done to make it work
		 */

		const setupBaB = new Promise((resolve, reject) => {
			try {
				this.editMode = true;
				this.setBoxType(type == "build-a-box" ? "custom" : "preset");
				this.navigate(3, 0);
				resolve();
			} catch {
				reject();
			}
		});
		const styleBaB = new Promise((resolve, reject) => {
			try {
				// Set subscription to true
				this.querySelector('[for="bab-sub"]').click();
				this.subscription = true;

				// Hide things
				this.querySelectorAll(`.box-subscription`).forEach(
					(el) => (el.style.display = "none")
				);

				// Steps updates
				this.atc.innerHTML = "Confirm Changes";
				this.querySelector(".progress-1")?.classList.add("hidden");
				this.querySelector(".progress-2 span:first-child").innerHTML = "Step 1";
				this.querySelector(".progress-2 .custom").innerHTML = ": Edit your box";
				this.querySelector(".progress-3 span:first-child").innerHTML = "Step 2";

				// Hide subscription/one time options on confirmation page
				this.querySelector(".box-subscription").previousSibling.style.display =
					"none";

				// Back button width + display
				this.productBackBtn.style.display = "none";
				this.productNextBtn.classList.remove("basis-2/3");

				// Add text after confirm changes
				const copy = document.createElement("p");
				copy.className += "text-sm text-center mt-4";
				const copyText = document.createTextNode(
					"You will need to checkout again in order to confirm changes to your subscription."
				); //TODO: Copy coming from Kelsey
				copy.append(copyText);
				document.querySelector(".js-box-atc").parentNode.append(copy);
				resolve();
			} catch {
				reject();
			}
		});
		const populateBoxProduct = new Promise((resolve, reject) => {
			try {
				const boxVids = boxData.map((v) => v.vid);

				// Populate box product
				if (type == "build-a-box-pre-built-bundle") {
					// Spoof first box-size click, as all preset are 14 packs
					this.setSelectedSize(this.sizeInputsTrigger[0].querySelector('input'));
				} else {
					// Find which box-size
					this.sizeInputsTrigger.forEach((trigger) => {
						const boxSizeData = JSON.parse(trigger.querySelector('input').value);
						if (boxVids.indexOf(Number(boxSizeData.variant_id)) != -1) {
							this.setSelectedSize(trigger);
						}
					});
				}

				resolve();
			} catch {
				reject();
			}
		});
		const populateBoxItems = new Promise((resolve, reject) => {
			try {
				const addVariantToBaB = (variant) => {
					const babProd = document.querySelector(
							`build-a-box-product[data-variant-id="${variant.vid}"]:not([data-handle="build-a-box-pre-built-bundle"])`
						);
					if (babProd) {
						babProd.quantity = variant.quantity;
						babProd.productLine.quantity = variant.quantity;
						babProd.productLine.points =
							babProd.points * parseInt(babProd.productLine.quantity);
						babProd.input.value = variant.quantity;
						this.lineItemModify(babProd.productLine);
						this.animateProduct(
							babProd.productLine,
							true,
							variant.quantity,
							true
						);
						babProd.previousValue = variant.quantity;

						// Allow editing via minus button
						babProd.querySelector(
							"quantity-input button:first-child"
						).disabled = false;
					}
				}

				// NOTE: We needed this slight delay so that the products would update in the sidebar.
				const addAllVariantsToBaB = boxData.map((variant) =>
					new Promise(resolve =>
						setTimeout(() => {
							addVariantToBaB(variant);
							resolve();
						}, 50))
				);

				Promise.all(addAllVariantsToBaB).then(resolve).catch(reject);
			} catch {
				reject();
			}
		});

		Promise.all([setupBaB, styleBaB, populateBoxProduct, populateBoxItems]).then(() => {
			this.open();
		}).catch(() => {
			console.log("There was an error opening your product in edit mode.")
		});

		// this.open();
	}

	openPresetBundle(bundleTitle = "Best Variety Box") {
		this.open();
		this.setBoxType("preset");
		this.navigate(3, 0);
		this.selectPresetBundle(bundleTitle);
	}

	close() {
		this.tabIndex = -1;

		this.isOpen = false;

		lockScroll(false);

		gsap.to(this.bab, {
			y: this.closedOffset,
			ease: "elastic.out(1,0.7)",
		});

		gsap.to(this.overlay, {
			opacity: 0,
			ease: "elastic.out(1,0.7)",
			duration: 0.2,
		});

		// this.focusTrap.deactivate();
	}

	setFocusTrap(container) {
		// if (typeof container == "undefined" || !this.focusTrap) {
		// 	this.focusTrap = window.Zero.FocusTrap.createFocusTrap(container || this);
		// } else {
		// 	this.focusTrap.updateContainerElements(container);
		// }

		// if (!this.focusTrap.active) {
		// 	this.focusTrap.activate();
		// }
	}

	selectPresetBundle(bundleTitle) {
		const bundleBoxProduct = document.querySelector(
			`build-a-box-product[data-title="${bundleTitle}"]`
		);
		// if (!bundleBoxProduct) return;

		bundleBoxProduct.querySelector(`button`).click();
		bundleBoxProduct.style.order = -1;
	}

	/**
	 * Modify our line item object
	 * @param {*} object
	 */
	lineItemModify(object, add = true) {
		/** Check capacity */
		this.products[object.line.variant] = object;
		this.productCount = Object.keys(this.products).reduce(
			(v, obj) => v + this.products[obj].quantity,
			0
		);
		this.pointsCount = Object.keys(this.products).reduce(
			(v, obj) => v + this.products[obj].points,
			0
		);
		this.boxPrice = Object.keys(this.products).reduce(
			(v, obj) => v + this.products[obj].price * this.products[obj].quantity,
			0
		);

		let pointsLeft = this.productMax - this.pointsCount;

		/** Check buttons for disable state */
		[...this.buildableProducts].forEach((product) => {
			let button = product.querySelector("[name='plus']");
			let wrap = product.children[0];

			// Disable
			if (product.dataset.points > pointsLeft) {
				button.disabled = true;
				button?.blur();
				wrap.classList.add("disabled");

				return;
			}

			// Enable
			button.disabled = false;
			wrap.classList.remove("disabled");
		});

		/** Set our box price */
		this.displayPrice(this.boxPrice, object?.discountOverride);

		/** Next button check */

		if (pointsLeft <= 0.75) {
			let max = parseInt(this.productMax);
			if (parseInt(this.productMax) < 20 && !this.editMode && this.boxContext == 'custom') {
				this.upgradeModal.open();
			}
			this.productNextBtn.disabled = false;
			this.boxFull = true;
			/** Check if current size is greater than "Small" box capacity, disable selection */
		} else {
			this.productNextBtn.disabled = true;
			this.boxFull = false;
		}

		/** Write line item summary */
		this.writeLineItems();
	}

	enableAllAddButtons() {
		[...this.buildableProducts].forEach((product) => {
			let button = product.querySelector("[name='plus']");
			let wrap = product.children[0];
			button.disabled = false;
			wrap.classList.remove("disabled");
		});
	}

	upgradeSize() {
		// Force change dispatch
		this.setSelectedSize(this.sizeInputs[1].closest('button'));

		this.productNextBtn.disabled = true;
		this.boxFull = false;

		this.enableAllAddButtons();

		// TODO: what do we do if the user goes back and selects a smaller box again?

		// Temporarily disable editing this box again
		this.prevTabBtns.forEach((btn) => {
			btn.disabled = true;
		});

		this.upgradeModal.close();

		this.animateProduct(this.productLine, false);
	}

	displayPrice(price = null, discount = null) {
		let origPrice = price || this.boxPrice;
		let setPrice = price || this.boxPrice;
		let setText = window.Zero.Intl.format(setPrice);

		if (this.boxContext == "preset" && !discount) {
			discount = this.presetJson?.subscription_discount
				? parseFloat(this.presetJson.subscription_discount)
				: 0;
		}

		if (this.subscription === true) {
			let discountPercent =
				discount != null
					? discount
					: parseFloat(this.sizeJson.subscription_discount);

			setPrice = price * ((100 - discountPercent) / 100);
			setText = `<span class="discount">${window.Zero.Intl.format(
				origPrice
			)}</span>${window.Zero.Intl.format(setPrice)}`;
		}

		/** Set our box price */
		[...this.priceEl].forEach((el) => {
			el.innerHTML = setText;
		});
	}

	/**
	 *
	 */
	writeLineItems(singleHandle = null) {
		let handles = "";
		let prodString = "";

		Object.keys(this.products).forEach((prod, key) => {
			handles += `${key > 0 ? "|" : ""}${this.products[prod].handle}:${
				this.products[prod].quantity
			}`;
		});

		prodString = `|||${handles}|||`;

		let now = (Date.now ? Date.now() : new Date().getTime()) / 1000;

		fetch(
			`${window.Shopify.routes.root}?section_id=endpoint--build-a-box&key=${now}&products=${prodString}`
		)
			.then((response) => {
				if (!response.ok) {
					let error = new Error(response.status);

					throw error;
				}

				return response.text();
			})
			.then((text) => {
				let dom = new DOMParser().parseFromString(text, "text/html");
				let markup = dom.querySelector(
					"#shopify-section-endpoint--build-a-box"
				).innerHTML;

				this.summaries.length == 0
					? this.emptyStates.forEach((el) => el.classList.remove("hidden"))
					: this.emptyStates.forEach((el) => el.classList.add("hidden"));

				[...this.summaries].forEach((el) => {
					el.innerHTML = markup;
				});

				window.Zero.lazyLoad.update();

				this.locked = false;
			})
			.catch((error) => {
				this.locked = false;

				throw error;
			});
	}

	/**
	 * Animate from frame to frame
	 * @param {*} prev
	 * @param {*} next
	 */
	animateFrames(prev, next, callback = () => {}) {
		// next.classList.remove("hidden");
		// prev.classList.remove("hidden");

		this.locked = true;

		this.hideShowTab(next);

		// gsap.fromTo(
		// 	prev,
		// 	{
		// 		x: 0,
		// 	},
		// 	{
		// 		x: this.currentFrame > this.nextStep ? "100%" : "-100%",
		// 		// onComplete: () => {
		// 		// 	prev.classList.add('hidden');
		// 		// }
		// 	}
		// );

		// gsap.fromTo(
		// 	next,
		// 	{
		// 		x: this.currentFrame > this.nextStep ? "-100%" : "100%",
		// 	},
		// 	{
		// 		x: 0,
		// 		onComplete: () => {
		// 			this.locked = false;

		// 			callback();
		// 		},
		// 	}
		// );
	}

	/**
	 * Animate from tab to tab (inside frame)
	 */
	animateTabs(prev, next, callback = () => {}) {
		// gsap.fromTo(
		// 	prev,
		// 	{
		// 		opacity: 1,
		// 	},
		// 	{
		// 		opacity: 0,
		// 		pointerEvents: "none",
		// 	}
		// );
		// gsap.fromTo(
		// 	next,
		// 	{
		// 		opacity: 0,
		// 	},
		// 	{
		// 		opacity: 1,
		// 		pointerEvents: "all",
		// 		onComplete: () => {
		// 			this.locked = false;
		// 			callback();
		// 		},
		// 	}
		// );
	}

	/**
	 * Animate product in listing
	 */
	animateProduct(object, add = true, count = 1, immediate = false) {
		/** Animate capacity bar */
		gsap.to(this.capacityBars, {
			width: Math.round((this.pointsCount / this.productMax) * 100) + "%",
			duration: immediate ? 0 : 0.3,
		});

		if (count < 0) count = count * -1;

		/** remove product */
		if (add === false && !!object) {
			let existingVariants = this.productAnimEl.querySelectorAll(
				`[data-id="${object.line.variant}"]`
			);

			for (let i = 0; i < count; i++) {
				let lastVariantAdded =
					existingVariants[existingVariants.length - (1 + i)];

				lastVariantAdded.dataset.id = null;

				gsap.to(lastVariantAdded, {
					width: 0,
					duration: immediate ? 0 : 0.3,
					delay: immediate ? 0 : 0.15,
				});

				gsap.to(lastVariantAdded.querySelector("img"), {
					y: "-150px",
					duration: immediate ? 0 : 0.5,
					onComplete: () => {
						lastVariantAdded.remove();
					},
				});
			}

			return;
		}

		/** add product */
		if (object) {
			for (let i = 0; i < count; i++) {
				let div = document.createElement("div");
				let img = document.createElement("img");

				div.classList = "summary-image";
				div.dataset.id = object.line.variant;
				div.style = `z-index: ${--this.countdown};`; // Design fix because of the structural heirarchy

				img.src = object.image;

				div.append(img);

				this.productAnimEl.appendChild(div);

				/** now animate */
				gsap.to(div, {
					width: this.productMax > 20 ? "15px" : "30px",
					duration: immediate ? 0 : 0.3,
					delay: immediate ? 0 : 0.05 * i,
				});

				gsap.to(img, {
					x: "-35px",
					duration: immediate ? 0 : 0.5,
					delay: immediate ? 0 : 0.05 * i,
				});
			}
		}
	}

	/**
	 * Cancel former box before callback
	 */
	cancelBox(callback) {
		this.atc.disabled = true;
		this.atc.textContent = "Please wait";

		//This data is set in _subscriptions.js in the ReCharge theme when the edit box flow begins
		const cancelData = JSON.parse(localStorage.getItem("editBaBCancel"));
		fetch(
			"https://lzh0ne30p4.execute-api.us-east-2.amazonaws.com/default/updateSubscription",
			{
				method: "POST",
				body: JSON.stringify({
					type: cancelData.type, //"cancel"
					token: cancelData.token,
					subscriptions: cancelData.subscriptions,
				}),
			}
		)
			.then((response) => {
				// The API call was successful!
				return response.text();
			})
			.then((json) => {
				if (json.length > 2) {
					//Not an empty JSON object
					callback();
				} else {
					throw "Error cancelling order";
				}
			})
			.catch((error) => {
				console.log("Error in cancelling your order", error);
				this.atc.disabled = false;
				this.atc.textContent = "Please try again";
			});
	}

	/**
	 * Add to Cart
	 */
	addToCart() {
		this.dataObj = {
			items: [],
		};

		// if (this.boxContext === 'custom') {

		// Data, first item is always the box
		this.boxProduct = {
			id: this.sizeJson.variant_id,
			quantity: 1,
			properties: {
				SKU: this.sizeJson.sku,
				_box_key: this.boxId,
			},
		};

		this.dataObj.items.push(this.boxProduct);

		// NOTE: This was the old discount method. I've coded it out now that subs are no longer available.
		// Discount codes
		// if (this.subscription === true) {
		// 	// add subscription
		// 	this.dataObj.items[0].selling_plan = this.sizeJson.selling_plan_id;
		// 	this.dataObj.items[0].properties._discount =
		// 		this.sizeJson?.subscription_discount;
		// 	this.dataObj.items[0].properties._discount_shipping = "FREE";
		// 	this.dataObj.items[0].properties._discount_subscription =
		// 		this.sizeJson.subscription_discount_code;
		// 	this.dataObj.discounts = [
		// 		this.sizeJson.subscription_discount_code,
		// 		this.sizeJson.subscription_shipping_code,
		// 	];
		// 	this.dataObj.discount = this.sizeJson.subscription_discount_code;
		// }

		// NOTE: This leverages app Advanced Shopping Rules to create a shipping discount for the BaB. See https://admin.shopify.com/store/smartsweets/apps/vendor-shipping-rules-1/method/edit/1027284
		// if (parseInt(this.productMax) > 20) {
		// 	this.dataObj.items[0].properties._discount_shipping = "FREE";
		// }

		// }

		Object.keys(this.products).forEach((prod) => {
			let data = this.products[prod];
			let obj = {
				id: data.line.variant,
				quantity: data.quantity,
			};

			if (data.line.properties) {
				obj.properties = data.line.properties;
			}

			// Selling plan ID
			if (this.subscription === true && data.line.selling_plan_id) {
				obj.selling_plan = data.line.selling_plan_id;

				if (!obj.properties) obj.properties = {};

				obj.properties._discount = this.sizeJson?.subscription_discount;
			}

			// add to box line properties
			if (this.boxContext === "custom") {
				this.dataObj.items[0].properties[data.title] = data.quantity;
			}

			// add item to line items
			this.dataObj.items.push(obj);
		});

		// if (this.boxContext !== "custom" && this.subscription === true && this.dataObj.items[0]) {

		// 	// add subscription
		// 	this.dataObj.items[0].properties._discount_shipping = "FREE";
		// }

		let url = window.Shopify.routes.root + "cart/add.js";

		// Apply shipping discount
		// if (parseInt(this.sizeJson.max_size) == 28) {
		// 	fetch(`/discount/${this.dataset.shippingDiscount}`);
		// }

		fetch(url, {
			method: "POST",
			headers: {
				Accept: "application/json",
				"Content-Type": "application/json",
			},
			body: JSON.stringify(this.dataObj),
		})
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				checkCart();

				// close BAB
				this.close();

				// reset BAB
				// let updateUrl = `/discount/${dataObj.discount}?redirect=/cart?discount=${dataObj.discounts.join(",")}`;
				let updateUrl = `${window.Shopify.routes.root}cart`;
				if (this.editMode) {
					updateUrl = `${window.Shopify.routes.root}checkout?editBaBCancel=${localStorage.getItem(
						"editBaBCancel"
					)}`;
				}

				if (this.subscription === true) {
					//} && this.boxContext == "custom") {

					// Store discount junk
					if (
						this.appliedDiscountValue < this.sizeJson?.subscription_discount
					) {
						window.localStorage.setItem("discount_code", this.dataObj.discount);
						window.localStorage.setItem(
							"discount_value",
							this.sizeJson?.subscription_discount
						);

						updateUrl = `${window.Shopify.routes.root}discount/${this.dataObj.discount}?redirect=/cart`;
						if (this.editMode) {
							updateUrl = `${window.Shopify.routes.root}discount/${
								this.dataObj.discount
							}?redirect=${window.Shopify.routes.root}checkout?editBaBCancel=${localStorage.getItem(
								"editBaBCancel"
							)}`;
						}
					}
				}

				// navigate to cart page
				const productCounts = Object.values(this.products).reduce((acc, p) => {
					if (!acc[p.handle]) acc[p.handle] = { quantity: 0, image: p.image };
					acc[p.handle].quantity += p.quantity;
					return acc;
				}, {});

				window.candy.runAnimation({
					callback: () => {
						if (window.location.pathname == updateUrl) {
							window.location.reload();
						}
						else {
							window.location.href = updateUrl;
						}
					},
					setsImage: true,
					productCounts
				});
			})
			.catch((error) => {
				console.error("Error:", error);
			});
	}

	resetAll() {
		//  Forget prev ID
		this.boxId = generateGuid();

		this.emptyStates.forEach((el) => {
			el.classList.remove("hidden");
		});
		this.summaries.forEach((el) => {
			el.textContent = "";
		});

		// this.writeLineItems(null);
		//  Empty all data objs
		this.boxContext = null;
		this.boxProduct = null;
		this.dataObj = null;
		this.selectedPreset = null;
		this.selectedSize = null;
	}
}

class BuildABoxProduct extends HTMLElement {

	constructor() {

		super();

		this.productId = this.dataset.productId;
		this.variantId = this.dataset.variantId;
		this.sellingPlanId = this.dataset.sellingPlanId;
		this.sellingPlanDiscount = this.dataset.sellingPlanDiscount;
		this.sectionId = this.dataset.sectionId;
		this.image = this.dataset.image;
		this.handle = this.dataset.handle;
		this.price = this.dataset.price;
		this.sku = this.dataset.sku;
		this.title = this.dataset.title;
		this.bundle = this.dataset.bundle;

		this.box = this.closest("build-a-box");
		this.input = this.querySelector('[name="quantity"]');
		this.default = this.input?.defaultValue || 0;
		this.previousValue = parseInt(this.default);
		this.quantity = this.input?.value || "1";
		this.points = parseFloat(this.dataset.points);

		if (this.input) {
			this.input.addEventListener("change", this.quantityChange.bind(this));
		}

		/**
		 * Object structure for build-a-box
		 */
		this.productLine = {
			quantity: parseInt(this.quantity),
			image: this.image,
			price: this.price,
			handle: this.handle,
			title: this.title,
			discountOverride: this.sellingPlanDiscount,
			points: this.points * parseInt(this.quantity),
			line: {
				id: parseInt(this.productId),
				variant: parseInt(this.variantId),
				selling_plan_id: (this.sellingPlanId) ? parseInt(this.sellingPlanId) : null,
				properties: {
					SKU: this.sku,
					_box_key: this.box.boxId
				}
			}
		};
	}

	/**
	 *
	 * @param {*} event
	 * @returns
	 */
	quantityChange(event) {
		let target = event.target;
		let newValue = parseInt(target.value);
		let diffValue = newValue - this.previousValue;
		let maxAddition = this.box.productMax - this.box.productCount;
		let pointsLeft = (this.productMax - this.productCount);

		if (this.box.locked === true) {
			event.stopPropagation();
			event.preventDefault();

			event.target.value = this.previousValue;
			return;
		}

		if (diffValue > maxAddition && maxAddition > 0) {
			const tmpNewValue = target.value - (diffValue - maxAddition);
			newValue = tmpNewValue;
			event.target.value = newValue;
		}

		this.box.locked = true;

		let addition = (parseInt(this.previousValue) < parseInt(newValue)) ? true : false;

		if (this.box.productCount >= this.box.productMax && addition == true) {
			event.stopPropagation();
			event.preventDefault();

			event.target.value = this.previousValue;

			this.box.locked = false;

			return;
		}

		this.productLine.quantity = parseInt(newValue);
		this.productLine.points = this.points * parseInt(newValue);
		this.previousValue = parseInt(this.productLine.quantity);

		this.box.lineItemModify(this.productLine, addition);
		this.box.animateProduct(this.productLine, addition, diffValue);
	}
}

export {
	BuildABox,
	BuildABoxProduct
}
